/**
 * Application's entry point
 */
import { MainThemeHandler } from '@vendor/js/theme';
import Common from '@vendor/js/common';
import '@vendor/libs/moment/moment';
import '@app/layouts';
import '@app/pages';
import '@app/components';
import '@app/common';
import _Config from '@vendor/js/config';
const init = () => {
    try {
        MainThemeHandler.init();
        Common.init();
        window.Config = _Config;
    }
    catch (err) {
        console.error(err);
    }
};
if (typeof window != 'undefined') {
    init();
}
